import { useShow } from '@pankod/refine-core';
import { Show, Typography, Row, Col, Card, Divider } from '@pankod/refine-antd';
import { IWarehouse } from 'interfaces';
import { PointOfContactTable } from 'components/point-of-contact';
import { AddressShow, PageHeader } from 'components';

const { Title, Text } = Typography;

export const WarehouseShow = () => {
  const { queryResult } = useShow<IWarehouse>({
    metaData: {
      fields: [
        'id',
        'name',
        'email',
        'warehouseCode',
        'mobileNumber',
        {
          address: ['street', 'area', 'city', 'country', 'zip'],
        },
      ],
    },
  });

  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <>
      <Show isLoading={isLoading} headerProps={{ extra: <PageHeader path="/warehouses" /> }}>
        <Row justify="space-around" align="middle">
          <Col xs={24} lg={12}>
            <Card title="Information">
              <Title level={5}>Name</Title>
              <Text>{record?.name}</Text>
              <Title level={5}>Email</Title>
              <Text>{record?.email}</Text>
              <Title level={5}>Mobile Number</Title>
              <Text>{record?.mobileNumber}</Text>
              <Title level={5}>Unique ID</Title>
              <Text>{record?.warehouseCode}</Text>
            </Card>
            <Card title="Address" style={{ marginTop: '32px' }}>
              <AddressShow
                street={record?.address?.street}
                area={record?.address?.area}
                city={record?.address?.city}
                country={record?.address?.country}
                zip={record?.address?.zip}
              />
            </Card>
          </Col>
        </Row>
      </Show>
      <Divider />
      <Row wrap={false}>
        <Col flex="auto">
          {record?.id && <PointOfContactTable resource="warehouse" resourceId={record?.id} />}
        </Col>
      </Row>
    </>
  );
};
